// import React, { createContext, useContext, useRef } from "react";

// const ScrollContext = createContext();

// export const useScroll = () => {
//     return useContext(ScrollContext);
// };

// export const ScrollProvider = ({ children }) => {
//     // Create a ref container to manage multiple refs

//     const scrollToSection = (ref) => {
//         if (ref && ref.current) {
//             const element = ref.current;
//             const rect = element.getBoundingClientRect();
//             const scrollTop =
//                 window.pageYOffset || document.documentElement.scrollTop;
//             const top = rect.top + scrollTop - 100;

//             window.scrollTo({
//                 top,
//                 behavior: "smooth",
//             });
//         } else {
//             console.error("Ref is not available:", ref);
//         }
//     };

//     const contactform = useRef(null);
//     const faq = useRef(null);
//     const pricing = useRef(null);
//     const contextValue = {
//         contactform,
//         faq,
//         pricing,
//         scrollToSection,
//     };

//     return (
//         <ScrollContext.Provider value={contextValue}>
//             {children}
//         </ScrollContext.Provider>
//     );
// };


// src/context/scroll-context.js
import React, { createContext, useContext, useRef, useMemo } from "react";

const ScrollContext = createContext(null);

export const useScroll = () => useContext(ScrollContext);

export const ScrollProvider = ({ children }) => {
    // Section refs
    const contactform = useRef(null);
    const faq = useRef(null);
    const pricing = useRef(null);

    /**
     * Smoothly scroll to a section with an adjustable offset (e.g. for sticky header)
     * Usage: scrollToSection(contactform) or scrollToSection(contactform, { offset: 100 })
     */
    const scrollToSection = (ref, opts = {}) => {
        const el = ref?.current;
        if (!el) {
            console.error("scrollToSection: ref is not available", ref);
            return;
        }

        const prefersNoMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
        const behavior = prefersNoMotion ? "auto" : (opts.behavior || "smooth");
        const offset = typeof opts.offset === "number" ? opts.offset : 100; // default header offset

        // Measure + scroll inside rAF to minimize layout thrash
        requestAnimationFrame(() => {
            const rect = el.getBoundingClientRect(); // single read = ok
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
            const targetY = rect.top + currentScrollY - offset;

            window.scrollTo({
                top: Math.max(0, targetY),
                left: 0,
                behavior,
            });
        });
    };

    const value = useMemo(
        () => ({
            contactform,
            faq,
            pricing,
            scrollToSection,
        }),
        []
    );

    return <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>;
};
